/* Pattumart — show only the selected colour's photos in the product gallery.
   Each product image's alt text holds its colour (e.g. "Pink"). When a shopper
   picks a colour, photos whose alt matches stay visible and the rest are hidden.
   If no photo matches the chosen colour, every photo is shown (nothing breaks). */
(function () {
  if (window.__pmVariantMedia) return;
  window.__pmVariantMedia = true;

  var HIDE = 'pm-vm-hide';
  var style = document.createElement('style');
  style.textContent = '.' + HIDE + '{display:none !important}';
  document.head.appendChild(style);

  var COLOR_RE = /^(colou?rs?|shade)$/i;

  function norm(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/[-_]+/g, ' ')
      .replace(/\s+\d+$/, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function optionName(el) {
    var fs = el.closest('fieldset');
    var legend = fs && fs.querySelector('legend');
    if (legend) return legend.textContent.split(':')[0].trim();
    var name = el.getAttribute('name') || '';
    var m = name.match(/^options\[(.+)\]$/);
    if (m) return m[1];
    return name.replace(/-\d+$/, '');
  }

  function selectedColour(scope) {
    var root = scope.querySelector('variant-selects, variant-radios') || scope;
    var found = null;
    root.querySelectorAll('input[type="radio"]:checked, select').forEach(function (el) {
      if (found !== null) return;
      if (COLOR_RE.test(optionName(el))) found = el.value;
    });
    return found;
  }

  function scopeFor(gallery) {
    return gallery.closest('product-info, .shopify-section, quick-add-modal, product-modal') || document;
  }

  function altOf(item) {
    var img = item.querySelector('img');
    return img ? img.getAttribute('alt') : '';
  }

  function apply(gallery) {
    var colour = selectedColour(scopeFor(gallery));
    var slides = gallery.querySelectorAll('[id^="Slider-Gallery"] > li[data-media-id]');
    var thumbs = gallery.querySelectorAll('[id^="Slider-Thumbnails"] > li[data-target]');
    if (!slides.length) return;

    var want = colour === null ? null : norm(colour);
    var keep = {};
    var matches = 0;
    if (want) {
      slides.forEach(function (li) {
        if (norm(altOf(li)) === want) { keep[li.dataset.mediaId] = true; matches++; }
      });
    }
    var showAll = !want || matches === 0;

    var changed = false;
    slides.forEach(function (li) {
      var hide = !showAll && !keep[li.dataset.mediaId];
      if (li.classList.contains(HIDE) !== hide) { li.classList.toggle(HIDE, hide); changed = true; }
    });
    thumbs.forEach(function (li) {
      var hide = !showAll && !keep[li.dataset.target];
      if (li.classList.contains(HIDE) !== hide) { li.classList.toggle(HIDE, hide); changed = true; }
    });
    if (!changed) return;

    // Keep the slider counters and arrows in step with the visible photos.
    gallery.querySelectorAll('slider-component').forEach(function (s) {
      if (typeof s.resetPages === 'function') { try { s.resetPages(); } catch (e) {} }
    });
    var total = gallery.querySelector('.slider-counter--total');
    if (total) total.textContent = showAll ? slides.length : matches;

    // If the photo on screen is now hidden, switch to the first visible one.
    var active = gallery.querySelector('[id^="Slider-Gallery"] > li.is-active');
    if (active && active.classList.contains(HIDE) && typeof gallery.setActiveMedia === 'function') {
      var first = gallery.querySelector('[id^="Slider-Gallery"] > li[data-media-id]:not(.' + HIDE + ')');
      if (first) { try { gallery.setActiveMedia(first.dataset.mediaId, false); } catch (e) {} }
    }
  }

  var queued = false;
  function run() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      document.querySelectorAll('media-gallery').forEach(apply);
    });
  }

  function init() {
    if (!document.querySelector('media-gallery')) return;
    run();
    document.addEventListener('change', function (e) {
      if (e.target.closest('variant-selects, variant-radios, product-form, .product-form__input')) run();
    });
    // The theme re-renders parts of the page after a variant change; re-apply then.
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', run);
})();
